import { Checkbox, EmptyView, Trans } from '@/components'

import { IFile } from '../fs'
import { GalleryItem } from './GalleryItem'

interface FileGalleryProps {
  files: IFile[]
  selectedRows: IFile[]
  onSelectionChange: (file: IFile, checked: boolean) => void
  onFileClick: (file: IFile) => void
  onSelectAll?: (checked: boolean) => void
}

export function FileGallery({
  files,
  selectedRows,
  onSelectionChange,
  onFileClick,
  onSelectAll,
}: FileGalleryProps) {
  if (files.length === 0) {
    return <EmptyView title={<Trans i18nKey="common.emptyViewNoDataMsg" />} />
  }

  return (
    <div>
      {/* Select All */}
      {onSelectAll && (
        <div className="mb-3 bg-neutral-50 rounded-lg px-4 py-2.5 t-sb text-tertiary">
          <Checkbox
            checked={files.length > 0 && selectedRows.length === files.length}
            onChange={onSelectAll}
            inputClassName="w-4 h-4"
            checkedBgColor="bg-btn-secondary"
            checkedBorderColor="border-none"
            checkIconColor="text-white"
          >
            <Trans i18nKey="data.allFiles">All Files</Trans>
          </Checkbox>
        </div>
      )}

      {/* Gallery Grid */}
      <div className="flex flex-wrap gap-3">
        {files.map((file) => (
          <GalleryItem
            key={file.id}
            file={file}
            selected={selectedRows.some((row) => row.id === file.id)}
            onSelect={(checked) => onSelectionChange(file, checked)}
            onClick={() => onFileClick(file)}
          />
        ))}
      </div>
    </div>
  )
}
